import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

export function initArtistGallery() {
  if (!document.querySelector('.artysta-single__gallery-item')) return;

  GLightbox({
    selector: '.artysta-single__gallery-item',
  });
}
